import React from 'react'
import MenuDrawer from '../DrawerMenu/component/MenuDrawer'

const MenuComponent = () => {
  return (
    <MenuDrawer />
  )
}

export default MenuComponent
